import script from "./Candles.vue?vue&type=script&lang=js"
export * from "./Candles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__